import React from 'react';
import { PropTypes as PT } from 'prop-types';
import classes from './Badge.module.scss';

/**
 * Badge component
 * This component will display the badge with count
 * @param {Number} count - number to display in badge (if > 99 then it displays 99+)
 */
class Badge extends React.PureComponent {
  render() {
    const className = this.props.className ? `${classes.badge} ${this.props.className}` : classes.badge;
    return (
      <div className={className} data-testid="btn-badge">
        <span>{this.props.count > 99 ? '99+' : this.props.count}</span>
      </div>
    );
  }
}

Badge.propTypes = {
  count: PT.number.isRequired,
  className: PT.string
};

Badge.defaultProps = {
  count: 0,
  className: null
};

export default Badge;
